import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function SystemdCheatSheet() {
    return (
        <div className={globalStyles.article}>
            <h1>systemd / systemctl cheat sheet</h1>

            <p>systemd is the init system used by most modern distros (Debian, Ubuntu, CentOS/RHEL, Fedora, Arch...).
                It manages <b>units</b> — services, timers, sockets, mounts — and <b>systemctl</b> is the tool used
                to control them.</p>

            <h3>Controlling a service</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Common commands</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>systemctl start nginx</code></td>
                        <td>Start the service now</td>
                    </tr>
                    <tr>
                        <td><code>systemctl stop nginx</code></td>
                        <td>Stop the service now</td>
                    </tr>
                    <tr>
                        <td><code>systemctl restart nginx</code></td>
                        <td>Stop then start</td>
                    </tr>
                    <tr>
                        <td><code>systemctl reload nginx</code></td>
                        <td>Reload config without dropping connections (if supported)</td>
                    </tr>
                    <tr>
                        <td><code>systemctl status nginx</code></td>
                        <td>Show state, recent logs and the PID</td>
                    </tr>
                    <tr>
                        <td><code>systemctl enable nginx</code></td>
                        <td>Start automatically on boot</td>
                    </tr>
                    <tr>
                        <td><code>systemctl disable nginx</code></td>
                        <td>Don't start automatically on boot</td>
                    </tr>
                    <tr>
                        <td><code>systemctl enable --now nginx</code></td>
                        <td>Enable and start in one go</td>
                    </tr>
                    <tr>
                        <td><code>systemctl is-enabled nginx</code></td>
                        <td>Check whether it's set to start on boot</td>
                    </tr>
                    <tr>
                        <td><code>systemctl is-active nginx</code></td>
                        <td>Check whether it's currently running</td>
                    </tr>
                    <tr>
                        <td><code>systemctl list-units --type=service</code></td>
                        <td>List all loaded service units</td>
                    </tr>
                    <tr>
                        <td><code>systemctl list-unit-files --state=enabled</code></td>
                        <td>List every unit enabled to start on boot</td>
                    </tr>
                    <tr>
                        <td><code>systemctl daemon-reload</code></td>
                        <td>Reload unit files after editing one (required before the change takes effect)</td>
                    </tr>
                    <tr>
                        <td><code>systemctl mask nginx</code></td>
                        <td>Block the unit from being started at all, even manually</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <p>Add <code>--user</code> to any command to manage services for the current user instead of the system
                (e.g. <code>systemctl --user restart my-agent</code>).</p>

            <h3>Reading the logs</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> journalctl -u nginx <i># all logs for the unit</i><br/>
    <b>user@host:~$</b> journalctl -u nginx -f <i># follow, like tail -f</i><br/>
    <b>user@host:~$</b> journalctl -u nginx --since "1 hour ago"<br/>
            </pre>

            <h3>Unit file locations</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Where units live</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>/usr/lib/systemd/system/</b></td>
                        <td>Units shipped by installed packages — don't edit directly</td>
                    </tr>
                    <tr>
                        <td><b>/etc/systemd/system/</b></td>
                        <td>Local overrides and custom units — this is where you add your own</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <p>See <b>Autostart on boot</b> for a walkthrough of writing a custom service unit for your own
                application.</p>
        </div>
    )
}
